import api from '@/api'
import {
  SET_USER_RECHARGE_QUERY,
  INIT_USER_RECHARGE_QUERY,
  SET_USER_RECHARGE_SEARCHING,
  SET_USER_RECHARGE_EXPORTING,
  SET_AGENCY_LIST,
} from './mutation-types.js'
import files from 'file-saver'
import {getHeaderName} from '@/utils'
import { RefundType } from '../../../constants/filters.js'
import { checkUserName } from '@/views/User/utils'
import { i18n } from '@/i18n'

const initQuery = () => {
  const newDate = new Date()
  const currentDate = new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate())
  const prevDate = new Date(currentDate)
  prevDate.setDate(prevDate.getDate() - 1)
  const startDate = `${prevDate.getFullYear()}/${prevDate.getMonth() + 1}/${prevDate.getDate()} 00:00:00`
  const endDate = `${currentDate.getFullYear()}/${currentDate.getMonth() + 1}/${currentDate.getDate()} 23:59:59`

  return {
    // pageNum: 1,
    // pageSize: 50,
    startTimeStamp: new Date(startDate).getTime(),
    endTimeStamp: new Date(endDate).getTime(),
    isDomestic: '', // 1:国内 2:国外
    userId: '', // 用户id
    mainUserId: '', // 年会说：上面那个 userId 在别的地方用了查询，会和别的查询条件有冲突，他那边就只能新开一个 mainUserId 字段
    mainUsername: '', // 主账号
    queryRelateUser: 0, // 查询关联账号信息 1 关联 0 不关联
    queryRelateUserId: 0, // 查询关联用户 ID 信息 1 关联 0 不关联
    transactionId: '', // 交易流水号
    remark: '', // 备注
    timeStatus: '0', // 按提交时间
    saleMan: '', // 业务员
    saleManId: '', // 业务员id
    areaId: '', // 区域id
    agentId: '', // 代理商id
    unallocatedAdmin: '',  // 未分配业务员
    adminName: '', // 管理员名称
    verifyStatus: '', // 对账状态
    businessType: '', // 业务类型
    isInternalTestAccount: '',  // 收入类型
  }
}

const queryAdminByOrganizationType = () => {
  return {                   // 通过组织类型查找管理员
    loginName: '',           // 登录名
    reallyName: '',          // 名字全称
  }
}

const state = {
  initQuery: initQuery(),
  query: initQuery(),
  queryAdmin: queryAdminByOrganizationType(),
  searching: false,
  exporting: false,
  agentList: [],
}

const mutations = {
  [SET_USER_RECHARGE_QUERY] (state, payload) {
    state.query = {
      ...state.query,
      ...payload,
    }
  },
  [INIT_USER_RECHARGE_QUERY] (state, payload) {
    state.query = initQuery()
  },
  [SET_USER_RECHARGE_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [SET_USER_RECHARGE_EXPORTING] (state, payload) {
    state.exporting = payload
  },
  [SET_AGENCY_LIST] (state, payload) {
    state.agentList = payload
  },

}

/* eslint-disable */
const actions = {
  // 根据类型获取管理员名单
  async getAdminByOrganization ({state, commit}, payload) {
    const query = {
      ...state.queryAdmin,
      ...payload,
    }
    const {data} = await api.userApi.queryAdminByOrganizationType(query)
    if (query.organizationType === 4) {
      commit(SET_AGENCY_LIST, data)
    }
  },
  async getUserBalanceSumList ({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.userBalanceList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async getConsumeDetailList ({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.userConsumeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async getRechargeDetailList ({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.userRechargeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async queryUserCouponsByCondition ({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.queryUserCouponsByCondition(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async getRefundList ({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      let res = {data: []}
      const {refundType, ...params} = payload
      if (refundType === RefundType.Render) {
        res = await api.userApi.userRefundList(params)
      } else {
        res = await api.userApi.getCopyrightRefundList(params)
      }
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async getVoucherList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.userVoucherList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async getMemberRechargeList ({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.memberRechargeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async getCopyrightRechargeList({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.copyrightRechargeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async getCopyrightFeeList({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.copyrightFeeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async getTransferList ({commit, dispatch}, payload) {
    try {
      commit(SET_USER_RECHARGE_SEARCHING, true)
      const res = await api.userApi.userAccountTransList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (e) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async exportUserBalanceSumList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportUserBalanceList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async exportConsumeDetailList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      await api.userApi.exportUserConsumeList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async exportRechargeDetailList({commit, dispatch}, payload) {
    commit(SET_USER_RECHARGE_EXPORTING, true)
    const res = await api.userApi.exportUserRechargeList(payload)
    if (res.code === 200) {
      vm.$message({message: i18n.t('common_exportList_tips'), type: 'success'})
    } else {
      vm.$message({message: i18n.t('common_export_failed'), type: 'error'})
    }
    // try {
    //   const {data, headers} = res
    //   const fileName = getHeaderName(headers)
    //   const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
    //   files.saveAs(blob, fileName)
    // } catch (e) {
      // const reader = new FileReader()
      // reader.onload = () => {
      //   const result = JSON.parse(reader.result)
      //   const { code, data } = result
      //   checkUserName({
      //     code,
      //     data,
      //     callback: ({userId}) => {
      //       const { mainUsername, ...other } = payload
      //       dispatch('exportRechargeDetailList', {
      //         ...other,
      //         mainUserId: userId,
      //       })
      //     },
      //   })
      // }
      // reader.readAsText(res.data)
    // }
    commit(SET_USER_RECHARGE_EXPORTING, false)
  },
  async exportUserCoupons({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      let {data, headers} = await api.userApi.exportUserCoupons(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      if (data.type === 'application/json') {
        return data
      } else {
        const fileName = getHeaderName(headers)
        const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
        files.saveAs(blob, fileName)
      }
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async exportRefundList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportUserRefundList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async exportTransferList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportUserAccountTransList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async exportUserVoucherList ({commit, dispatch}, payload) {
    commit(SET_USER_RECHARGE_EXPORTING, true)
    const res = await api.userApi.exportUserVoucherList(payload)
    const {data, headers} = res
    try {
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      const reader = new FileReader()
      reader.onload = () => {
        const result = JSON.parse(reader.result)
        const { code, data } = result
        checkUserName({
          code,
          data,
          callback: ({userId}) => {
            const { mainUsername, ...other } = payload
            dispatch('exportUserVoucherList', {
              ...other,
              mainUserId: userId,
            })
          },
        })
      }
      reader.readAsText(res.data)
    }
    commit(SET_USER_RECHARGE_EXPORTING, false)
  },
  async exportCopyrightRechargeList({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportCopyrightRechargeList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async exportMemberRechargeList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportMemberRechargeList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  changeQuery ({commit}, payload) {
    commit(SET_USER_RECHARGE_QUERY, payload)
  },
  initQuery({commit}) {
    commit(INIT_USER_RECHARGE_QUERY)
  },
  async getSalesManList ({commit}, payload) {
    const {data} = await api.userApi.queryAdminByOrganizationType({organizationType: payload})
    return data
  },
  async getPackNodeConsumeList ({commit, dispatch}, payload) {
    commit(SET_USER_RECHARGE_SEARCHING, true)
    try {
      const res = await api.userApi.getPackNodeConsumeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (err) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async exportPackNodeConsumeList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportPackNodeConsumeList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async getPackProjectConsumeList ({commit, dispatch}, payload) {
    commit(SET_USER_RECHARGE_SEARCHING, true)
    try {
      const res = await api.userApi.getPackProjectConsumeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (err) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async exportPackProjectConsumeList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportPackProjectConsumeList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async getRentNodeConsumeList ({commit, dispatch}, payload) {
    commit(SET_USER_RECHARGE_SEARCHING, true)
    try {
      const res = await api.userApi.getRentNodeConsumeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (err) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async exportRentNodeConsumeList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportRentNodeConsumeList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
  async getRentNodeOverdueConsumeList ({commit, dispatch}, payload) {
    commit(SET_USER_RECHARGE_SEARCHING, true)
    try {
      const res = await api.userApi.getRentNodeOverdueConsumeList(payload)
      commit(SET_USER_RECHARGE_SEARCHING, false)
      return res
    } catch (err) {
      commit(SET_USER_RECHARGE_SEARCHING, false)
    }
  },
  async exportRentNodeOverdueConsumeList ({commit}, payload) {
    try {
      commit(SET_USER_RECHARGE_EXPORTING, true)
      const {data, headers} = await api.userApi.exportRentNodeOverdueConsumeList(payload)
      commit(SET_USER_RECHARGE_EXPORTING, false)
      const fileName = getHeaderName(headers)
      const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      files.saveAs(blob, fileName)
    } catch (e) {
      commit(SET_USER_RECHARGE_EXPORTING, false)
    }
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
